import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { ITemplateSearchDto, ModuleType, TokenType } from "@framework/types";
import { EthInput } from "@dzambalaorg/mui-inputs-mask";
import { FormGrid } from "@dzambalaorg/ui-kit";

interface ITemplateSearchFormProps {
  initialValues: Partial<ITemplateSearchDto>;
  contractType: Array<TokenType>;
  contractModule: Array<ModuleType>;
  embedded?: boolean;
}

export const TemplateSearchForm = (props: ITemplateSearchFormProps) => {
  const { initialValues, contractType, contractModule, embedded } = props;

  const { query, contractIds, minPrice, maxPrice } = initialValues;
  const fixedValues: Partial<ITemplateSearchDto> = { query, contractIds, minPrice, maxPrice };

  return (
    <SearchWithFilters initialValues={fixedValues} hasSearchField={!embedded}>
      <FormGrid
        columns={!embedded ? [2, 1] : [2]}
        containerProps={{ sx: theme => ({ marginTop: theme.spacing(theme.tokens.spacing.sm) }) }}
      >
        <EthInput name="minPrice" />
        <EthInput name="maxPrice" />

        {!embedded && (
          <EntityInput
            name="contractIds"
            controller="contracts"
            multiple
            fetchData={{ contractType, contractModule }}
          />
        )}
      </FormGrid>
    </SearchWithFilters>
  );
};
